<template>
  <div>
    <v-card class="mx-auto">
      <v-card-text class="pa-5 black--text">
        <v-row v-for="(kategori, id) in schema" :key="id">
          <v-col v-if="!kategori.hidden" cols="12">
            <div :class="['font-weight-medium mb-1', kategori.class]" style="font-size: 20px">
              {{ kategori.title }}
            </div>
            <base-form-generator :schema="kategori.laporan" v-model="form" class="pt-4" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import BaseFormGenerator from '@components/base/BaseFormGenerator';

export default {
  name: 'FormTopikPmo',
  components: { BaseFormGenerator },
  props: {
    masters: {
      type: Object,
      default: () => {},
    },
    isPreview: {
      type: Boolean,
      default: false,
    },
    isEntry: {
      type: Boolean,
      default: true,
    },
    id: {
      type: [Number, String],
      default: '',
    },
    laporan: {
      type: Object,
      default: () => {},
    },
    detail: {
      type: Object,
      default: () => {},
    },
    pelaksana: {
      tyep: Object,
      default: () => {},
    },
    pendampinganKe: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      form: {},
    };
  },
  computed: {
    mSubtopikKp() {
      const master = Object.assign({}, this.$getDeepObj(this.masters, 'kp_subtopik_psp') || {});

      return Object.keys(master)
        .filter((key) => +master[key][0] === +this.form.k_kp_topik_psp)
        .map((key) => {
          return {
            text: master[key][1],
            value: +key,
          };
        });
    },

    mOpsiPj() {
      return [
        ...this.masters['pic-opsi'],
        ...[
          {
            text: 'Lainnya',
            value: -1,
          },
        ],
      ];
    },

    mPendampingan() {
      return this.pelaksana.pendampingan_ke || {};
    },

    schema() {
      const bulan = this.mPendampingan[this.pendampinganKe];
      const urutan = {
        1: 'Topik Pertama',
        2: 'Topik Kedua',
        3: 'Topik Ketiga',
      };
      const pics = this.$arrToObj(this.masters['pic-opsi'] || [], 'value');

      return {
        dasar: {
          title: 'Topik Permasalahan',
          hidden: !this.isEntry,
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Urutan topik permasalahan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: urutan[this.id] || '',
              grid: { cols: 12, md: 6 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VSelect',
              name: 'k_kp_topik_psp',
              label: 'Topik permasalahan',
              placeholder: 'Pilih Topik',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.$mapForMaster(this.$getDeepObj(this.masters, 'kp_topik_psp') || {}),
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              required: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VAutocomplete',
              name: 'k_kp_subtopik_psp',
              label: 'Subtopik dari Topik permasalahan',
              placeholder: 'Pilih Subtopik',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.mSubtopikKp || [],
              grid: { cols: 12, md: 6 },
              outlined: true,
              dense: true,
              required: true,
              singleLine: true,
              hideDetails: true,
            },
          ],
        },
        'preview-dasar': {
          title: 'Topik Permasalahan',
          hidden: this.isEntry,
          class: 'mt-5',
          laporan: [
            {
              type: 'textView',
              label: 'Bulan Pelaksanaan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: bulan || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Urutan topik permasalahan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: urutan[this.id] || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Topik permasalahan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.laporan, 'm_kp_topik_psp.data.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
            {
              type: 'textView',
              label: 'Subtopik dari Topik permasalahan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.laporan, 'm_kp_subtopik_psp.data.keterangan') || '',
              grid: { cols: 12, md: 6 },
            },
          ],
        },
        lanjut: {
          title: 'Tindak Lanjut',
          hidden: !this.isEntry,
          laporan: [
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VTextarea',
              name: 'masalah',
              label: 'Isu / Masalah',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi',
              hint: 'wajib diisi',
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              counter: true,
              hideDetails: true,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VTextarea',
              name: 'rencana',
              label: 'Rencana Kegiatan',
              labelColor: 'indigo',
              placeholder: 'Tuliskan deskripsi',
              hint: 'wajib diisi',
              outlined: true,
              dense: true,
              singleLine: true,
              rows: 2,
              autoGrow: true,
              counter: true,
              hideDetails: true,
              counterValue: (v) => this.$wordCount(v),
              grid: { cols: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VAutocomplete',
              name: 'ptk_id',
              label: 'Penanggung Jawab',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              filter: this.customFilter,
              items: this.mOpsiPj,
              itemText: 'text',
              itemValue: 'value',
              hideDetails: true,
              outlined: true,
              dense: true,
              singleLine: true,
              grid: { cols: 12, md: 3 },
              useOthers: true,
              othersValue: -1,
              others: {
                disabled: this.isPreview || !this.isEntry,
                type: 'VTextField',
                name: 'pic',
                label: 'Penanggung jawab lainnya',
                hint: 'wajib diisi',
                required: true,
                outlined: true,
                dense: true,
                singleLine: true,
                hideDetails: true,
                grid: { cols: 12, md: 6 },
              },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_progres_psp',
              label: 'Status',
              placeholder: 'Pilih status',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.masters['topik-opsi'],
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VDatePicker',
              name: 'tgl_mulai',
              label: 'Tenggat Waktu',
              labelColor: 'indigo',
              placeholder: 'Pilih tanggal mulai',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              dense: true,
              grid: { cols: 12, md: 3, sm: 12 },
            },
            {
              disabled: this.isPreview || !this.isEntry,
              type: 'VDatePicker',
              name: 'tgl_selesai',
              label: 'Tenggat Waktu (selesai)',
              labelColor: 'white',
              placeholder: 'Pilih tanggal selesai',
              usePrependInnerIcon: 'mdi-calendar-month',
              hint: 'wajib diisi',
              outlined: true,
              singleLine: true,
              dense: true,
              grid: { cols: 12, md: 3, sm: 12 },
            },
          ],
        },
        'preview-lanjut': {
          title: 'Tindak Lanjut',
          hidden: this.isEntry,
          class: 'mt-8',
          laporan: [
            {
              type: 'textView',
              label: 'Isu / Masalah',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.laporan, 'masalah') || '',
              grid: { cols: 12 },
            },
            {
              type: 'textView',
              label: 'Rencana Kegiatan',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$getDeepObj(this.laporan, 'rencana') || '',
              grid: { cols: 12 },
            },
            {
              type: 'textView',
              label: 'Penanggung Jawab',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.laporan.ptk_id ? pics[this.laporan.ptk_id]?.text ?? '' : this.laporan.pic || '',
              grid: { cols: 12, md: 3 },
            },
            {
              type: 'textView',
              label: 'Tenggat Waktu',
              labelColor: 'indigo',
              bgColor: 'grey lighten-3 pa-2 mb-4',
              value: this.$durasi(this.laporan.tgl_mulai, this.laporan.tgl_selesai, { shortDate: true }) || '',
              grid: { cols: 12, md: 3 },
            },
            {
              disabled: this.isPreview,
              type: 'VSelect',
              name: 'k_progres_psp',
              label: 'Status',
              placeholder: 'Pilih status',
              labelColor: 'indigo',
              hint: 'wajib diisi',
              items: this.masters['topik-opsi'],
              outlined: true,
              singleLine: true,
              readonly: this.readOnly,
              dense: true,
              grid: { cols: 12, md: 6, sm: 12 },
            },
          ],
        },
      };
    },
  },
  methods: {
    reset() {
      this.$set(this, 'form', {});

      if (this.$isObject(this.laporan)) {
        const instrumens = this.$getDeepObj(this.detail, 'psp_kp_pa_sekolah_instrumens.data') || [];
        const instrumensObj = this.$arrToObj(instrumens, 'k_kp_instrumen_psp');

        for (const sch of Object.values(this.schema)) {
          for (const input of sch.laporan) {
            if (input.type !== 'textView') {
              if (/instrumen/.test(input.name)) {
                const ins = input.name.split('-');
                this.$set(this.form, input.name, this.$getDeepObj(instrumensObj[ins[1] || ''], `deskripsi`) || '');
              } else {
                this.$set(this.form, input.name, this.laporan[input.name] || '');
              }
            }
          }
        }

        if (!this.laporan.ptk_id && this.laporan.pic) {
          this.$set(this.form, 'ptk_id', -1);
          this.$set(this.form, 'pic', this.laporan.pic);
        }
      }
    },

    customFilter(item, queryText) {
      const textOne = item.text.toLowerCase();
      const searchText = queryText.toLowerCase();
      return textOne.indexOf(searchText) > -1 || textOne.indexOf('lain') > -1;
    },

    getValue() {
      let values = Object.assign({}, this.form);

      if (!this.isEntry) {
        const paramStatus = ['k_kp_topik_psp', 'k_kp_subtopik_psp', 'k_progres_psp'];
        for (const param in values) {
          if (!paramStatus.includes(param)) {
            delete values[param];
          }
        }

        return values;
      }

      if (values.ptk_id === -1) {
        delete values['ptk_id'];
      }

      return values;
    },
  },
};
</script>
<style scoped>
.bg-kiri {
  background: #bbdefb;
  height: 100%;
}
.sc-notif {
  background-color: #c8e6c9;
}
.v-expansion-panel-content >>> .v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
